import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39157750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "singnForm" }
const _hoisted_2 = {
  key: 0,
  class: "bind-text"
}
const _hoisted_3 = { class: "bind" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 1,
  class: "login_logo flex-ter flex-cen"
}
const _hoisted_6 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/signup/istumoSNIFF_logo.png",
  alt: "",
  style: {"width":"180px"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "formBox" }
const _hoisted_9 = { class: "country form-item flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_11 = { class: "label-title" }
const _hoisted_12 = { class: "fx-1" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "form-item flex verifyCode" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_17 = { class: "label-title" }
const _hoisted_18 = { class: "err-msg" }
const _hoisted_19 = { class: "form-item verifyCode flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_21 = { class: "label-title" }
const _hoisted_22 = { class: "err-msg" }
const _hoisted_23 = { class: "form-item flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_25 = { class: "label-title" }
const _hoisted_26 = { class: "err-msg" }
const _hoisted_27 = { class: "form-item verifyCode flex" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_29 = { class: "label-title" }
const _hoisted_30 = { class: "err-msg" }
const _hoisted_31 = {
  key: 2,
  class: "form-item flex verifyCode"
}
const _hoisted_32 = { class: "label-title" }
const _hoisted_33 = { class: "flex-1 flex-col" }
const _hoisted_34 = {
  class: "countryTips",
  style: {"font-size":"12px","line-height":"1","padding-top":"5px"}
}
const _hoisted_35 = { class: "err-msg" }
const _hoisted_36 = {
  key: 3,
  class: "form-item flex"
}
const _hoisted_37 = {
  class: /*#__PURE__*/_normalizeClass(`label `)
}
const _hoisted_38 = { class: "label-title" }
const _hoisted_39 = {
  key: 4,
  class: "form-item aucfun flex"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_41 = { class: "label-title" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi tooltip_icon iconfont-tishi" }, null, -1))
const _hoisted_43 = { class: "aucfanEmalTip" }
const _hoisted_44 = { class: "err-msg" }
const _hoisted_45 = {
  key: 5,
  class: "form-item flex"
}
const _hoisted_46 = { class: "label-title" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = { class: "err-msg" }
const _hoisted_50 = { class: "foo flex-aiend flex-cen flex-col" }
const _hoisted_51 = {
  key: 0,
  class: "operate"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "to-login" }
const _hoisted_54 = { class: "to-index" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "bar" }
const _hoisted_57 = { class: "term-warp" }
const _hoisted_58 = { class: "is-argee-error" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_61 = { class: "flex-col flex-ter other_info" }
const _hoisted_62 = { class: "slotBox" }
const _hoisted_63 = {
  key: 0,
  class: "platfroms"
}
const _hoisted_64 = ["onClickPassive"]
const _hoisted_65 = ["src", "alt"]
const _hoisted_66 = ["innerHTML"]

import {
  reactive,
  ref,
  onMounted,
  nextTick,
  watch,
  computed
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ArrowLeftBold, Warning } from '@element-plus/icons-vue'
import TermModal from '@/components/termModal/index.vue'

import {
  getSignupCode,
  signup as signApi,
  activateSub,
  checkInvitationCode,
  getEffectTermByType,
  getInvitationInfo,
  getMobileCode,
  MobileCodeParams,
  isBind,
  loginByPwd
} from '@/apis/login'
import { useRequest } from '@/util/useLoading'
import { t, changeLang } from '@/plugins/i18n'
import { isEmojiCharacter, wait } from '@/plugins/utils'
import { signup as createRules } from './rules'
import { useGetCode } from './utils'
import { countries, countryOptions, tips, Value } from './const'

import SvgIcon from '@/components/icons/SvgIcon.vue'
import {
  CountriesEnum,
  Site,
  japanStationCor2Country,
  koreaStationCor2Country,
  ukStationCor2Country,
  Term,
  compTripartitePlatforms,
  countryMapSite,
  Plat
} from '@/common/const'
import { ElMessage } from 'element-plus'
import { openAuth2, AuthResponse, UserInfo, platType, getQueryParams } from '@/plugins/tripartite-login'
import {
  REMOVE_TRIPARTITEUSERINFO,
  TripartiteUserInfo,
  UPDATE_TRIPARTITEUSERINFO
} from '@/store/modules/tripartite'
import { R, isJA, useSite, isEN } from '@/store'
import { taTrack, TaEvent, thinkingdata } from '@/util/buryingPoint'
import { constant } from 'lodash'
import { ta } from 'element-plus/lib/locale'
interface Props {
  /** boolean则是弹窗  string则是激活/创建子账号 */
  isRam?: string | boolean,
  h5?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isRam: { type: [String, Boolean], required: false },
    h5: { type: Boolean, required: false }
  },
  emits: ['success', 'cancel', 'update:panel'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** boolean则是弹窗  string则是激活/创建子账号 */
  isRam?: string | boolean,
  h5?: boolean
}
_useCssVars(_ctx => ({
  "e433ed4c": (_unref(inputPaddingRight))
}))

const locationSearch = window.location.search
// 注册渠道 email 邮箱 phone 手机号
const signupType = ref('email')
// 协议连接
const termFileUrl = ref('')

// 机器认证
const showRecaptcha = ref(false)
const vueRecaptchaRef = ref()
// 获取人机校验接口
const recaptchaVerified = async (res: any) => {
  form.recaptchaCode = res
  getPhoneCode({ customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: 1, countryPlaceCode: form.countryPlaceCode, recaptchaCode: res } as MobileCodeParams)
  showRecaptcha.value = false
}
const recaptchaExpired = () => {
  vueRecaptchaRef.value.reset()
}




// 若屏幕占用宽度小于700，则展示h5样式
const showh5Style = ref<boolean>(window.screen?.availWidth < 700)
const route = useRoute()
const router = useRouter()
const isJa = computed(() => isJA())
const store = useStore<R>()
/** 注册表单 */
const formRef = ref()
/** 协议弹窗 */
const termModal = ref()
/** 协议内容 */
const term = ref()
/** 国家手机区域列表 */
const mobileAreaCodeOptions = ref<{ value: string; label: string }[]>([])
/** 是否显示密码 */
// const showPassWord = ref(false)
/** 邀请码是否不可编辑 */
const invitationCodeDisable = ref(false)
/** 国家是否不可编辑 */
const countryPlaceCodeDisable = ref(false)
// 所有站点的用户协议
const termDataList: any = ref([])

/** 通过邀请码获取国家站点信息 */
const countriesInfo = ref({
  country: '',
  stationCode: '',
  langCode: ''
})

/** 站点信息 */
const stationCode = ref<Site>()
/** 注册绑定的三方平台 */
const signinPlatform = ref<string>()
/** store内的三方绑定信息 */
const tripartitePlatformInfo = computed<TripartiteUserInfo>(
  () => store.state.tripartite
)

/** 跳转第三方连接 */
const gotoUrl = (url: string) => {
  window.open(url, '_blank')
}

// 是否Aucfan 注册
const isAucfan = computed(() => route.query.channel === '1' && route.query.code === 'af0001')

/** 验证推广码是否为正确的推广联盟 */
const isSmcCode = ref(false)
const countryPlaceCode: any = (!props.isRam ? localStorage.getItem('countryKey') : '') || countries.find((item) => item.navigatorLang.includes(navigator.language))?.key || CountriesEnum.other
// 如果是弹窗则根据当前国家展示
if (props.isRam) {
  // todo 20231116邮箱注册  setItem没处理英国站  临时解决下
  if (!isEN()) {
    localStorage.setItem('countryKey', isJA() ? 'JP' : 'KO')
  } else {
    // todo 应该选中当前站点语言对应国家  临时写死UK
    localStorage.setItem('countryKey', CountriesEnum.UK)
  }
}
const countriesList = ref(countryOptions)

/** 注册表单值 */
const form = reactive<Value>({
  countryPlaceCode: CountriesEnum.Japan,
  gender: 3,
  verificationCode: '',
  countryCode: '',
  customerMobile: '',
  isagree: false,
  recommendationEmail: '',
  invitationCode: String(route.query.code ?? ''),
  recaptchaCode: '',
  corpName: ''
})
const { count, disabled, getPhoneCode, getCode } = useGetCode(
  'signupCode',
  getSignupCode,
  getMobileCode
)
// 渠道
const channel = ref('')
const channelGroup = ref('')

/** 表单验证规则 */
const rules = ref(createRules(form, disabled))
const defaultImageUrl =
  window.location.href.includes('from') && route.query.from !== 'ckbh5' ? 'https://static-s.theckb.com/BusinessMarket/Easy/H5/topLogo.png' : 'https://static-jp.theckb.com/static-asset/client/loginLogo.svg'

/** 登录并绑定点击功能区分 */
const toLogin = () => {
  const path = window.location.href
  // 若当前不是在/login,则应该是切换弹窗
  if (!path.includes('signup')) {
    store.commit('status/loginPanel', 'login')
  } else {
    router.push('/login')
  }
}

watch(() => store.getters.site, (val) => {
  // countriesList.value = getCountryOptions()
  let res = countryOptions
  if (props.isRam) {
    if (val === 'en') {
      res = res.filter(item => item.key !== 'JP' && item.key !== 'KR')
      return res
    } else {
      res = res.filter(item => item.key === (val === 'ja' ? 'JP' : 'KR'))
    }
  }
  countriesList.value = res
})

const getCountryOptions = (isAll = true) => {

}
const { query } = useRoute()
const [loading, submit] = useRequest(
  async () => {
    const { ...data } = form
    // 子账号注册
    if (typeof props.isRam === 'string') {
      const res = await activateSub({
        ...tripartitePlatformInfo.value,
        ...form,
        customerShopId: props.isRam
      })
      if (res.success) {
        // store.commit('route/SET_LOGIN_NAME', data.loginName)
        emits('success', res.data?.uuid)
        store.commit(REMOVE_TRIPARTITEUSERINFO)
        return wait()
      }
    } else {
      // 主账号注册
      const find = countries.find((country) => country.key === form.countryPlaceCode)
      // 默认携带from
      const res = await signApi({
        platformType: props.h5 ? 4 : 1,
        buType: 1,
        ...tripartitePlatformInfo.value,
        ...data,
        spm: String(route.query.spm ?? ''),
        channel: channelGroup.value ? `${channel.value}${channelGroup.value}` : channel.value,
        ext: route.query,
        invitationCode:
          form.invitationCode === 'itsumo' ? '001342' : String(form.invitationCode) || String(route.query.code || ''),
        utcTimeZone:
          form.countryPlaceCode === CountriesEnum.other
            ? getTimeZoneByBowser()
            : find?.time as string,
        termId: termDataList.value.find((i: any) => i.stationCode === stationCode.value)?.termId,
        initShopFlag: 1
      })
      if (res.success) {
        const { utm_source, utm_medium, utm_campaign, utm_content, channel: nChannel, channel_group } = getQueryParams()
        if (utm_source || nChannel || channel_group || utm_medium || utm_campaign || utm_content) {
          thinkingdata.userSetOnce(
            {
              register_ad_info: {
                utm_source, utm_medium, utm_campaign, utm_content, channel: nChannel, channel_group
              }
            }
          )
        }

        taTrack({
          event: TaEvent.REGISTER,
          value: {
            step_id: 'register_success'
          }
        })
        store.commit(REMOVE_TRIPARTITEUSERINFO)
        emits('success', res.data?.uuid, channel.value, data)
        store.commit('route/SET_LOGIN_NAME', data.loginName)
        if (isJA()) {
          // 刚注册的新用户
          sessionStorage.setItem('newUser', '1')
        }
        return wait()
      } else {
        taTrack({
          event: TaEvent.REGISTER,
          value: {
            step_id: 'register_fail',
            register_fail_reason: res?.msg
          }
        })
      }
    }
  },
  {
    onError: console.log
  }
)

/** 选中国家的国旗url */
const getSelectedCountryFlagUrl = (key?: string) =>
  countryOptions.find((op) => op.key === key)?.nationalFlagUrl || 'https://static-s.theckb.com/BusinessMarket/Client/JP.png'

/** 获取验证码码 */
const getVerifyCode = async () => {
  if (count.value > 0) return
  taTrack({
    event: TaEvent.REGISTER,
    value: {
      step_id: 'get_verification_code'
    }
  })
  const checkResult = await formRef.value.validateField([
    signupType.value === 'email' ? 'customerEmail' : 'customerMobile'
  ])
  console.log(checkResult)
  if (checkResult) {
    // 发送邮箱验证
    if (signupType.value === 'email') {
      getCode({ customerEmail: form.customerEmail, countryPlaceCode: form.countryPlaceCode })
      return
    }
    // 发送手机号验证码
    getPhoneCode({ customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: 1, countryPlaceCode: form.countryPlaceCode } as MobileCodeParams)
  }
  // showRecaptcha.value = true
  // vueRecaptchaRef.value.reset()
}

/** 返回浏览器当前的UTC时间偏移量 */
const getTimeZoneByBowser = () => {
  // 获取本地时间
  const localTime = new Date()

  // 计算UTC偏移量（以分钟为单位）
  const utcOffset = (localTime.getTimezoneOffset() / 60) * -1

  if (utcOffset >= 0) {
    return `UTC+${utcOffset}`
  } else {
    return `UTC${utcOffset}`
  }
}

/** 根据国家站点获取用户协议 */
const fetchTerm = async (state = stationCode.value as Site) => {
  try {
    const list = await getEffectTermByType({
      stationCode: state,
      type: Term.utilize
    })
    termDataList.value = [...list.data]
  } catch (error) {
    ElMessage.error(t('查询条款失败'))
  }
}

const getStationTerm = () => {
  console.log('222', stationCode.value)
  return termDataList.value.find((i: any) => i.stationCode === stationCode.value)?.fileUrl
}
/**
 * 验证邀请码
 * @param val 邀请码
 * @param notNeedRequest 是否需要请求
 */
const validInvitationCode = async (val: string, notNeedRequest?: boolean) => {
  if (!notNeedRequest) {
    if (val === 'itsumo') {
      await getCountryInvitationInfo('001342')
    } else {
      await getCountryInvitationInfo(val)
    }
  }

  const res = await checkInvitationCode({
    invitationCode: val
  })
  if (res?.success) {
    isSmcCode.value = res.data
  }
  // 如果路由上code存在，且为推广码，且该推广码正确
  if (route.query.code && res.data && countriesInfo.value?.country) {
    if (countriesInfo.value.stationCode === Site.EN) {
      countryPlaceCodeDisable.value = false
      invitationCodeDisable.value = true
      rules.value = createRules(form, disabled)
      return
    }
    countryPlaceCodeDisable.value = true
    invitationCodeDisable.value = true
    rules.value = createRules(form, disabled)
    return
  }
  if (res.data && countriesInfo.value?.country) {
    if (countriesInfo.value.stationCode === Site.EN) {
      countryPlaceCodeDisable.value = false
      rules.value = createRules(form, disabled)
      return
    }
    countryPlaceCodeDisable.value = true
    rules.value = createRules(form, disabled)
    return
  }
  countryPlaceCodeDisable.value = false
  invitationCodeDisable.value = false
  rules.value = createRules(form, disabled)
}
/** 判断国家是否disabled */
const getSingleCountryDisabled = (country: string) => {
  // 如果邀请码存在且正确，且站点为英国站站点,如果不是英国站的国家则不能选择
  if (isSmcCode.value && countriesInfo.value.stationCode === Site.EN && !ukStationCor2Country.includes(country)) {
    return true
  }
  return false
}

/**
 * 切换国家
 * @param val 国家站点
 */
const handleCountryChange = (val: CountriesEnum) => {
  const _invitationCode = form.invitationCode
  val && localStorage.setItem('countryKey', val)
  formRef.value && formRef.value.resetFields()
  //   如果是推广联盟邀请码，且是英国站点,则切换国家的时候邀请码不用置空
  if (isSmcCode.value && countriesInfo.value.stationCode === Site.EN) {
    form.invitationCode = _invitationCode
  }
  const find = countries.find((country) => country.key === val)
  let globalLangType: 'en' | 'ja' | 'ko' = 'en'
  const list = [find!.mobileAreaCode]
    .filter((code) => code)
    .map((code) => ({
      value: code,
      label: code
    }))
    .concat({
      label: '—',
      value: ''
    })
  mobileAreaCodeOptions.value = list
  form.countryCode = list[0].value

  if (japanStationCor2Country.includes(val)) {
    globalLangType = 'ja'
    stationCode.value = Site.JA
    signupType.value = 'email'
  }
  if (koreaStationCor2Country.includes(val)) {
    globalLangType = 'ko'
    stationCode.value = Site.KO
  }
  if (ukStationCor2Country.includes(val)) {
    globalLangType = 'en'
    stationCode.value = Site.EN
  }
  form.countryPlaceCode = val
  // 以弹窗形式打开的，不changeLangType，因为会刷新app/且langType本无需变化
  store.commit('route/site', globalLangType)
  changeLang(globalLangType)
}
/** 打开协议 */
const catTerm = async (fileUrl = '') => {
  termFileUrl.value = fileUrl || getStationTerm()
  nextTick(() => {
    if (termFileUrl.value) {
      termModal.value.open()
    }
  })
}
/** 同意点击 */
const onagree = () => {
  form.isagree = true
}
/** 不同意 */
const ondisAgree = () => {
  form.isagree = false
}
/** 表单第二步验证 */
const finishRegist = async () => {
  taTrack({
    event: TaEvent.REGISTER,
    value: {
      step_id: 'click_complete'
    }
  })
  // 因为第一步校验通过，所以全部校验，避免写if/else
  const checkResult = await formRef.value.validate()
  if (checkResult) {
    submit()
  }
}
/**
 * 三方授权回调
 * @param userInfo 用户信息回调
 */
const authCallback = async (userInfo?: TripartiteUserInfo) => {
  const res = await isBind({
    thirdPlatform: userInfo?.thirdPlatform,
    thirdCustomerId: userInfo?.thirdCustomerId
  })
  if (res.success) {
    const isbind = res.data?.isBind
    // 已经绑定过我们的账号,直接登录
    if (isbind) {
      const res2: any = await loginByPwd({
        password: '',
        nameOrEmail: '',
        thirdPlatform: userInfo?.thirdPlatform as string,
        thirdCustomerId: userInfo?.thirdCustomerId as string
      })
      if (res2?.success) {
        store.commit('status/onLogin', false)
        // 第一次注册，选择完平台后
        if (res2.data.uuid && !res2.data.token) {
          store.commit('route/uuid', res2.data.uuid)

          if (props.h5) {
            router.replace({ name: 'signup_h5', query })
          } else {
            router.replace({ name: 'signup' })
          }
        } else {
          const query = route.query
          const { redirect, from } = query ?? {}
          // 判断是否是h5商品详情推广页跳转过来的 如果是的就还要跳转回去
          if (redirect) {
            await store.dispatch('route/setToken', res2.data.token)
            window.location.replace(decodeURIComponent(redirect.toString()))
          } else {
            await store.dispatch('route/setPlat', res2.data.token)
          }
        }
      } else {
        if (res?.code === '24010003' && form.recaptchaCode) {
          form.recaptchaCode = ''
        }
      }
    }
    signinPlatform.value = userInfo?.thirdPlatform
    const customerEmail = userInfo?.thirdCustomerEmail as string
    if (customerEmail) {
      // formRef.value.validateField(['customerEmail'])
      form.customerEmail = userInfo?.thirdCustomerEmail as string
    }
    form.customerMobile = userInfo?.thirdCustomerPhone as string
    // 针对line仅日本授权
    if (userInfo?.thirdPlatform === Plat.LE) {
      forceSetJa()
    }
  }
}

/** 三方授权点击 */
const registerByPlatform = (platform: string) => {
  taTrack({
    event: TaEvent.REGISTER_METHOD_CLICK,
    value: {
      register_method: platform
    }
  })

  openAuth2(
    {
      plat: platform as platType,
      h5: props.h5
    },
    rsp => authCallback(rsp.userInfo)
  )
}

// 切换国家获取默认列表及手机号等，及规则
watch(
  () => form.countryPlaceCode,
  (countryPlaceCode) => {
    if (!countryPlaceCode) {
      getDefaultOptions()
    }
    fetchTerm()
    rules.value = createRules(form, disabled)
  }
)

/** 通过code获取站点信息 */
const getCountryInvitationInfo = async (code: string) => {
  // 新加接口判断code是正确

  const resInfo = await getInvitationInfo({
    invitationCode: code
  })
  // 说明邀请码不正确
  if (!resInfo.success || !resInfo.data) {
    countriesInfo.value = resInfo.data
    getDefaultOptions()
    return
  }

  countriesInfo.value = resInfo.data
  // 切换用户语言
  changeLang(resInfo.data?.langCode as ('ko' | 'ja' | 'en'))
  stationCode.value = resInfo.data?.stationCode as Site

  const find = countries.find((item) =>
    item.key === resInfo.data.country) ||
  {
    key: CountriesEnum.Japan,
    desc: '日本',
    navigatorLang: ['ja'],
    mobileAreaCode: '+81'
  }

  // 如果国家信息存在则将国家回显
  form.countryPlaceCode = (resInfo.data?.country ?? CountriesEnum.Japan) as CountriesEnum

  localStorage.setItem('countryKey', form.countryPlaceCode!)
  // 挂载时，需根据表单选中的国家，改变其手机区号的值和选项
  form.countryCode = find?.mobileAreaCode
  store.commit('route/site', resInfo.data?.langCode)
}

/** 强制设定为日本 */
const forceSetJa = (disabled = true) => {
  changeLang('ja')
  store.commit('route/site', 'ja')
  stationCode.value = Site.JA
  form.countryCode = '+81'
  form.countryPlaceCode = CountriesEnum.Japan
  // 国家是否可以选择
  countryPlaceCodeDisable.value = disabled
}

onMounted(() => {
  // 根据授权信息回填
  if (tripartitePlatformInfo.value.thirdPlatform) {
    authCallback(tripartitePlatformInfo.value)
    signinPlatform.value = tripartitePlatformInfo.value.thirdPlatform
  }
})

/** 走默认配置语言设置 */
const getDefaultOptions = () => {
  // 没有找对应语言的国家，默认日本
  const find = countries.find((item) =>
    item.navigatorLang.includes(store.getters.site === 'en' ? navigator.language : store.getters.site || navigator.language)
  ) || {
    key: CountriesEnum.other,
    desc: 'Other Countries And Regions',
    navigatorLang: ['*'],
    mobileAreaCode: ''
  }
  // 缓存国家key JP...  缓存key > 浏览器
  const cacheKey = localStorage.getItem('countryKey') as CountriesEnum
  // 弹窗不允许选中语言，所以与内部战点语言保持一致
  if (typeof props.isRam === 'boolean' && props.isRam) {
    form.countryPlaceCode = (isEN() ? cacheKey : '') || find?.key || CountriesEnum.other
  } else {
    form.countryPlaceCode = cacheKey || find?.key
  }

  localStorage.setItem('countryKey', form.countryPlaceCode)
  // 挂载时，需根据表单选中的国家，改变其手机区号的值和选项
  form.countryCode = find?.mobileAreaCode
  // 获取默认站点信息
  if (japanStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.JA
  }
  if (koreaStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.KO
  }
  if (ukStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.EN
  }
  console.log('getDefaultOptions', stationCode.value)
}
const isItsumoSignup = ref(false)
watch(() => route.query, async (val) => {
  if (isAucfan.value) {
    // 如果路由携带code参数，则是推广者联盟/acufn => 国家固定为日本，且无法选择国家
    forceSetJa()
    if (isAucfan.value) {
      invitationCodeDisable.value = true
    }
  }
  if (route.query.channel === 'itsumo') {
    forceSetJa(false)
    form.invitationCode = 'itsumo'
    form.invitationCode && validInvitationCode('001342')
    channel.value = '0'
    isItsumoSignup.value = true
  } else if (route.query.channel === '1688') {
    forceSetJa(false)
  } else {
    if (route.query.code) {
      // 如果路由携带code参数，则是推广者联盟 => 国家固定为日本，且无法选择国家
      form.invitationCode = String(route.query.code ?? '')
      form.invitationCode && validInvitationCode(form.invitationCode)
    }

    channel.value = String(route.query.channel ?? '')
    // 默认走缓存语言配置
    getDefaultOptions()
    form.countryPlaceCode && handleCountryChange(form.countryPlaceCode)
  }
  if (route.query.channel_group) {
    channelGroup.value = route.query.channel_group as string
  }
  fetchTerm()
}, { immediate: true })
// 切换邮箱or 手机号
const changeSignupType = (type: string) => {
  taTrack({
    event: TaEvent.REGISTER,
    value: {
      step_id: type === 'email' ? 'click_email_register' : 'click_phone_register'
    }
  })
  signupType.value = type
  form.customerEmail = ''
  form.customerMobile = ''
}
// defineExpose({
//   getStep
// })

const useEmailTips = ref()
const usePhoneRef = ref()
const inputPaddingRight = computed(() => {
  // 22 左右各11
  return `${((signupType.value === 'phone' ? useEmailTips?.value?.offsetWidth : usePhoneRef?.value?.offsetWidth) || 0) + 22}px`
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (typeof signinPlatform.value !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('注册并绑定您的THE CKB账户')), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('只需绑定一次，后续可用{platform}直接登录', {
          platform: signinPlatform.value
        })), 1)
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          (isItsumoSignup.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                height: "47",
                src: _unref(defaultImageUrl),
                alt: ""
              }, null, 8, _hoisted_7))
        ], 512)), [
          [_vShow, !__props.h5]
        ]),
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        formRef.value = _value
      },
      model: _unref(form),
      rules: rules.value,
      "validate-on-rule-change": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
            }, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('国家/地区')), 1)
            ], 2),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_form_item, {
                prop: "country",
                class: "selectTip"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"100%"},
                    placeholder: "请选择你的国家或地区",
                    modelValue: _unref(form).countryPlaceCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).countryPlaceCode) = $event)),
                    "popper-class": "h5-drap",
                    onChange: handleCountryChange,
                    disabled: !!countryPlaceCodeDisable.value || typeof __props.isRam === 'string'
                  }, {
                    prefix: _withCtx(() => [
                      _createElementVNode("img", {
                        src: getSelectedCountryFlagUrl(_unref(form).countryPlaceCode),
                        alt: "当前选中国家的国旗图片",
                        class: "selected-countryFlag"
                      }, null, 8, _hoisted_14)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countriesList.value, (op) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: op.key,
                          value: op.key,
                          label: op.desc,
                          disabled: getSingleCountryDisabled(op.key),
                          class: _normalizeClass(showh5Style.value ? 'op-h5' : 'op')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: op.nationalFlagUrl,
                              alt: "",
                              class: "op-img"
                            }, null, 8, _hoisted_13),
                            _createElementVNode("span", null, _toDisplayString(op.desc), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label", "disabled", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("div", { class: "countryTips" }, _toDisplayString(_unref(t)('注册成功后国家/地区无法更改，请谨慎选择')), 513), [
                [_vShow, !__props.isRam]
              ])
            ])
          ]),
          (signupType.value === 'phone')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                  }, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('手机号')), 1)
                  ], 2),
                  _createVNode(_component_el_form_item, {
                    class: "fx-1",
                    prop: "customerMobile"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        onBlur: _cache[2] || (_cache[2] = (e) => {
                if (!e.target?.value?.length) return
                _unref(taTrack)({
                  event: _unref(TaEvent).REGISTER,
                  value: {
                    step_id: 'fill_in_phone'
                  }
                })
              }),
                        type: "phone",
                        class: _normalizeClass(["customerMobile", showh5Style.value ? 'phone-input-h5' : 'phone-input customerMobile_withLoginForm']),
                        modelValue: _unref(form).customerMobile,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(t)(_unref(tips)[12]),
                        maxlength: 50
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "countryCode",
                            modelValue: _unref(form).countryCode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).countryCode) = $event)),
                            style: {"width":"68px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "class"]),
                      _createElementVNode("span", {
                        ref: (_value, _refs) => {
                          _refs['useEmailTips'] = _value
                          useEmailTips.value = _value
                        },
                        type: "text",
                        class: _normalizeClass([showh5Style.value ? 'phone-change-h5' : 'phone-change-pc', "phone"]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeSignupType('email')))
                      }, _toDisplayString(_unref(t)('使用邮箱注册')), 3)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                  }, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('手机验证码')), 1)
                  ], 2),
                  _createVNode(_component_el_form_item, {
                    prop: "verificationCode",
                    class: "fx-1"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        onBlur: _cache[5] || (_cache[5] = (e) => {
                if (!e.target?.value?.length) return
                _unref(taTrack)({
                  event: _unref(TaEvent).REGISTER,
                  value: {
                    step_id: 'fill_in_verification_code'
                  }
                })
              }),
                        type: "number",
                        modelValue: _unref(form).verificationCode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(t)(_unref(tips)[6]),
                        maxlength: 15
                      }, {
                        suffix: _withCtx(() => [
                          _createElementVNode("span", {
                            type: "text",
                            class: _normalizeClass({
                    getVerifyCode: _unref(count) === 0,
                    getVerifyCodeDisabled: _unref(count) > 0,
                  }),
                            onClick: getVerifyCode
                          }, _toDisplayString(_unref(count) > 0 ? `${_unref(t)('已发送')}(${_unref(count)})` : _unref(t)('获取验证码')), 3)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : (signupType.value === 'email')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                    }, [
                      _hoisted_24,
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('邮箱')), 1)
                    ], 2),
                    _createVNode(_component_el_form_item, {
                      class: "fx-1 rel",
                      prop: "customerEmail"
                    }, {
                      error: _withCtx((error) => [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(error.error), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onBlur: _cache[7] || (_cache[7] = (e) => {
                if (!e.target?.value?.length) return
                _unref(taTrack)({
                  event: _unref(TaEvent).REGISTER,
                  value: {
                    step_id: 'fill_in_email'
                  }
                })
              }),
                          class: _normalizeClass(["customerMobile verifyCode", showh5Style.value ? 'phone-input-h5' : 'phone-input customerMobile_withLoginForm']),
                          modelValue: _unref(form).customerEmail,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).customerEmail) = $event)),
                          modelModifiers: { trim: true },
                          maxlength: 50
                        }, null, 8, ["modelValue", "class"]),
                        (!_unref(isJA)())
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              ref: (_value, _refs) => {
                                _refs['usePhoneRef'] = _value
                                usePhoneRef.value = _value
                              },
                              type: "text",
                              class: _normalizeClass([showh5Style.value ? 'phone-change-h5' : 'phone-change-pc', "phone"]),
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (changeSignupType('phone')))
                            }, _toDisplayString(_unref(t)('使用手机号注册')), 3))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                    }, [
                      _hoisted_28,
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('邮箱验证码')), 1)
                    ], 2),
                    _createVNode(_component_el_form_item, {
                      prop: "verificationCode",
                      class: "fx-1"
                    }, {
                      error: _withCtx((error) => [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(error.error), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onBlur: _cache[10] || (_cache[10] = (e) => {
                if (!e.target?.value?.length) return
                _unref(taTrack)({
                  event: _unref(TaEvent).REGISTER,
                  value: {
                    step_id: 'fill_in_verification_code'
                  }
                })
              }),
                          class: "",
                          type: "number",
                          modelValue: _unref(form).verificationCode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                          modelModifiers: { trim: true },
                          placeholder: _unref(t)(_unref(tips)[6]),
                          maxlength: 15
                        }, {
                          suffix: _withCtx(() => [
                            _createElementVNode("span", {
                              type: "text",
                              class: _normalizeClass({
                    getVerifyCode: _unref(count) === 0,
                    getVerifyCodeDisabled: _unref(count) > 0,
                  }),
                              onClick: getVerifyCode
                            }, _toDisplayString(_unref(count) > 0 ? `${_unref(t)('已发送')}(${_unref(count)})` : _unref(t)('获取验证码')), 3)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", {
                  class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                }, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('手机号')), 1)
                ], 2),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_el_form_item, {
                    class: "fx-1",
                    prop: "customerMobile"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "phone",
                        onBlur: _cache[13] || (_cache[13] = (e) => {
                  if (!e.target?.value?.length) return
                  _unref(taTrack)({
                    event: _unref(TaEvent).REGISTER,
                    value: {
                      step_id: 'fill_in_phone'
                    }
                  })
                }),
                        class: _normalizeClass(["customerMobile", showh5Style.value ? 'phone-input-h5' : 'phone-input customerMobile_withLoginForm']),
                        modelValue: _unref(form).customerMobile,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(t)(_unref(tips)[12]),
                        maxlength: 50
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "countryCode",
                            modelValue: _unref(form).countryCode,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).countryCode) = $event)),
                            style: {"width":"68px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "class"]),
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('※填写手机号码，优先获得客服联系帮助')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('公司名称')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  class: "fx-1",
                  prop: "corpName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _unref(form).corpName,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).corpName) = $event)),
                      maxlength: "50"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(isAucfan))
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", {
                  class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                }, [
                  _hoisted_40,
                  _createElementVNode("span", _hoisted_41, "Aucfan.com" + _toDisplayString(_unref(t)('注册邮箱')), 1),
                  _createVNode(_component_el_popover, {
                    placement: "bottom",
                    width: 300,
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _hoisted_42
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('输入Aucfan的注册邮箱提示')), 1)
                    ]),
                    _: 1
                  })
                ], 2),
                _createVNode(_component_el_form_item, {
                  class: "fx-1",
                  prop: "recommendationEmail"
                }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_44, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _unref(form).recommendationEmail,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).recommendationEmail) = $event)),
                      maxlength: "50"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : (typeof __props.isRam !== 'string')
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                  }, [
                    _createElementVNode("span", _hoisted_46, [
                      _createTextVNode(_toDisplayString(_unref(t)('邀请码')) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "dark"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('为了告知介绍大使会员的用户名')), 1),
                          _hoisted_47,
                          _createTextVNode(" " + _toDisplayString(_unref(t)('请不要在用户名中注册包含能够识别个人身份的信息，比如真实姓名等。')), 1),
                          _hoisted_48,
                          _createTextVNode(" " + _toDisplayString(_unref(t)('如果用户名中包含您的个人信息，请事先同意提供给推广者会员。')), 1)
                        ]),
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_el_icon, { color: "#A1A1A1" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Warning))
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, isSmcCode.value]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ], 2),
                  _createVNode(_component_el_form_item, {
                    class: "fx-1",
                    prop: "invitationCode"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_49, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: _unref(form).invitationCode,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(form).invitationCode) = $event)),
                        disabled: invitationCodeDisable.value || isItsumoSignup.value,
                        maxlength: "6",
                        onChange: validInvitationCode
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ]),
        (_openBlock(), _createElementBlock("div", {
          class: "flex-col flex-aiend footer",
          key: _unref(form).countryCode
        }, [
          _createElementVNode("div", _hoisted_50, [
            (typeof signinPlatform.value === 'undefined')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  (!__props.isRam)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("span", _hoisted_53, [
                          _createVNode(_component_router_link, {
                            to: __props.h5 ? `/login_h5${_unref(locationSearch)}` : '/login'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('去登录')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        (!__props.h5)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_el_divider, { direction: "vertical" }),
                              _createElementVNode("span", _hoisted_54, [
                                _createVNode(_component_router_link, { to: "/" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('首页')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("span", {
                          class: "openLoginModal",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(store).commit('status/loginPanel', 'login')))
                        }, _toDisplayString(_unref(t)('去登录')), 1)
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              round: __props.h5,
              class: "next",
              color: "#FF5010",
              type: "success",
              loading: _unref(loading),
              onClick: finishRegist
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('注册完成')), 1)
              ]),
              _: 1
            }, 8, ["round", "loading"]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_el_form_item, {
                  prop: "isagree",
                  class: "is-argee-warp"
                }, {
                  error: _withCtx((valid) => [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("span", null, _toDisplayString(valid.error), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      fill: "#FF5010",
                      modelValue: _unref(form).isagree,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(form).isagree) = $event)),
                      size: "large",
                      class: "is-argee"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("span", {
                  class: "term",
                  innerHTML: _unref(t)('同意用户协议'),
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (catTerm()))
                }, null, 8, _hoisted_59)
              ])
            ])
          ]),
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            (typeof signinPlatform.value === 'undefined')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(compTripartitePlatforms), (platform) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: platform.key,
                      class: "platform",
                      onClickPassive: ($event: any) => (registerByPlatform(platform.key))
                    }, [
                      _createElementVNode("img", {
                        src: platform.logoUrl,
                        alt: _unref(t)('平台logo'),
                        height: "18",
                        width: "18"
                      }, null, 8, _hoisted_65)
                    ], 40, _hoisted_64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (typeof signinPlatform.value !== 'undefined')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "toBind",
                  onClick: toLogin,
                  innerHTML: _unref(t)('已有CKB账户，去【登录并绑定】')
                }, null, 8, _hoisted_66))
              : _createCommentVNode("", true)
          ])
        ]))
      ]),
      _: 3
    }, 8, ["model", "rules"]),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModal'] = _value
        termModal.value = _value
      },
      title: _unref(t)('利用规约'),
      onagree: onagree,
      "ondis-agree": ondisAgree,
      "file-url": termFileUrl.value,
      timer: false
    }, null, 8, ["title", "file-url"])
  ]))
}
}

})